module.exports = __webpack_public_path__ + "media/images/sp/site_navigation/icon_flow-0ad664c374b9d3d8832471698ff66fdf.svg";